<template>
  <footer class="relative">
    <!-- Trennlinie mit Gradient -->
    <div class="h-1 bg-gradient-to-r from-primary-500 via-secondary-500 to-primary-500 shadow-lg"></div>

    <!-- Footer Content -->
    <div class="bg-gradient-to-b from-gray-800 to-gray-900">
      <div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <!-- Logo und Beschreibung -->
        <div class="flex flex-col items-center justify-center">
          <img :src="logo" class="h-10 w-auto rounded bg-white p-1.5" alt="ArztUndPflegeJobs.de" />
          <p class="mt-3 text-center text-sm text-gray-400">
            Die Jobbörse für Ärzte und Pflegekräfte
          </p>
        </div>

        <!-- Navigation Links -->
        <nav class="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" aria-label="Footer">
          <template v-for="item in navigation" :key="item.name">
            <a
              v-if="item.external"
              :href="item.href"
              class="text-sm font-medium text-gray-400 transition-colors hover:text-primary-400"
            >
              {{ item.name }}
            </a>
            <Link
              v-else
              :href="item.href"
              class="text-sm font-medium text-gray-400 transition-colors hover:text-primary-400"
            >
              {{ item.name }}
            </Link>
          </template>
        </nav>

        <!-- Divider -->
        <div class="mx-auto mt-8 h-px w-48 bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>

        <!-- Copyright -->
        <p class="mt-6 text-center text-xs text-gray-500">
          &copy; {{ year }} pludoni GmbH. Alle Rechte vorbehalten.
        </p>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { Link, usePage } from "@inertiajs/inertia-vue3"
import { useI18n } from "vue-i18n"
import logo from "@/images/arztundpflegejobs/logo-wide.png"

const { t } = useI18n()

const { props: pageProps } = usePage()

const navigation = computed(() => [
  { name: t("components.footer.stellen_schalten"), href: "/arbeitgeber" },
  { name: t("components.footer.impressum"), href: "/impressum" },
  { name: t("components.footer.datenschutz"), href: "/datenschutz" },
])

const year = new Date().getFullYear()
</script>
